import FirstPage from '@/routes/apply/FirstPage.vue'
import ApplyFormPage from '@/routes/apply/FormPage.vue'
import ApplyResultPage from '@/routes/apply/ResultPage.vue'
import ApplyResultWithProductPage from '@/routes/apply/ResultWithProductPage.vue'
import SpecialOfferPage from '@/routes/apply/SpecialOffer.vue'

export default [
    {
        path: '/apply/first',
        name: 'FirstPage',
        component: FirstPage,
    },
    {
        path: '/apply/form',
        name: 'ApplyFormPage',
        component: ApplyFormPage,
    },
    {
        path: '/apply/result',
        name: 'ApplyResultPage',
        component: ApplyResultPage,
    },
    {
        path: '/apply/result-with-product',
        name: 'ApplyResultWithProductPage',
        component: ApplyResultWithProductPage,
    },
    {
        path: '/apply/special-offer',
        name: 'SpecialOfferPage',
        component: SpecialOfferPage,
    },
]
